import { render } from "./AskForQuoteHeader.vue?vue&type=template&id=799f9dfb"
import script from "./AskForQuoteHeader.vue?vue&type=script&lang=js"
export * from "./AskForQuoteHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__